import { Action, Reducer } from "redux";

export interface Texts {
  redirectButtonText?: string;
  confirmationHeader?: string;
  confirmationBody?: string;
  confirmationExtraInfo?: string;
  confirmationExtraUrl1?: {
    urlText?: string;
    link?: string;
  };
  confirmationExtraUrl2?: {
    urlText?: string;
    link?: string;
  };
  welcomeHeaderPartOneText?: string;
  ssnHeader?: string;
  orgHeader?: string;
  registrationNumberHeader?: string;
  carModelHeader?: string;
  checkoutButtonText?: string;
  coverageHeader?: string;
  changeChoiceText?: string;
  billingSectionHeader?: string;
  contactsSectionHeader?: string;
  trialPeriodMessage?: string;
  infoBlockText?: string;
  preliminaryPriceText?: string;
  antiTheftMessage?: string;
  dealerPrice?: {
    messageTop?: string;
    messageTopTitle?: string;
    messageBottom?: string;
  };
  confirmationLinks?: ConfirmationLinks;
  confirmationPromotion1?: Promotion;
  singleRecommendedButton?: string;
  discountMessageBoxText?: string;
  confirmationBottomSection?: Promotion;
  confirmationExistingCustomerHeader?: string;
  confirmationWithInstructionsHeader?: string;
  confirmationWithInstructionsBody?: string;
  confirmationManualInstructionsHeader?: string;
  confirmationInsuranceStartDate?: string;
  customisePageButton?: string;
  actualMilageHeader?: string;
  bonusSectionHeader?: string;
  batteryElectricMessage?: string;
  coverageDescriptions?: {
    coverageDescriptionSuper?: string;
    coverageDescriptionKasko?: string;
    coverageDescriptionDelkasko?: string;
    coverageDescriptionAnsvar?: string;
    coverageDescription_T1?: string;
    coverageDescription_T1D1?: string;
    coverageDescription_T1D1V1?: string;
    volviaComercialRecommendationOtherBrand_T1D1?: string;
    volviaComercialRecommendationOtherBrand_T1D1V1?: string;
    commercialCoverageDescriptionTraficLightTruck?: string;
    commercialCoverageDescriptionHalvLightTruck?: string;
    commercialCoverageDescriptionHelLightTruck?: string;
    commercialRecommendedCoverageDescriptionHelLightTruck?: string;
    coverageRecommendationDescription_T1?: string;
    coverageRecommendationDescription_T1D1?: string;
    coverageRecommendationDescription_T1D1V1?: string;
  };
  addonDescriptionMotor?: string;
  addonDescriptionLeiebil?: string;
  addonMotorCheckboxDescription?: string;
  addonCheckboxErrorMessage?: string;
  commercialTaxiMessage?: string;
  kamuxMessage?: string;
  persona?: {
    subtitle: string;
    imageUrl: string;
  };
}

export interface Promotion {
  link?: {
    url?: string;
    text?: string;
  };
  header?: string;
  body?: string;
}

export interface ConfirmationLinks {
  checkoutExtraUrl1?: {
    urlText?: string;
    link?: string;
  };
  checkoutExtraUrl2?: {
    urlText?: string;
    link?: string;
  };
}

export const CHANGE_REDIRECT_BUTTON_TEXT = "CHANGE_REDIRECT_BUTTON_TEXT";

const defaults: Texts = {
  redirectButtonText: "Return",
  confirmationHeader: "Tack för ditt köp",
  confirmationBody: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.",
  confirmationExtraInfo: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.",
  confirmationExtraUrl1: {
    urlText: "Tilbaka till polestarforsakring.se",
    link: "https://www.if.se",
  },
  confirmationExtraUrl2: {
    urlText: "Ga till polestar.com/se",
    link: "https://www.if.se",
  },
  welcomeHeaderPartOneText: "Välkommen",
  ssnHeader: "Personnr",
  orgHeader: "Organisationnummer",
  registrationNumberHeader: "Regnr",
  carModelHeader: "Modell",
  coverageHeader: "Dina val",
  changeChoiceText: "Ändra mina val",
  billingSectionHeader: "Datum & Betalning",
  contactsSectionHeader: "Kontaktuppgifter",
  coverageDescriptions: {
    coverageDescription_T1:
      "Tänk på att trafikförsäkringen inte täcker skador på din egen bil. Denna försäkring gäller bara för personskador och andras egendom som du skadar med din bil. Har du en äldre bil med lågt värde bör du ändå välja halvförsäkring för att få hjälp med bärgning.",
    coverageDescription_T1D1:
      "Halvförsäkring passar bra till nya bilar som har personvagnsgaranti (vagnskadegaranti), eller äldre bilar som inte har så högt värde längre. Bilens värde blir din självrisk om bilen totalskadas och du saknar helförsäkring/garanti. ",
    coverageDescription_T1D1V1:
      "Välj helförsäkring när bilen blir äldre än 3 år och  personvagnsgarantin (vagnskadegarantin) har upphört att gälla. Så länge garantin gäller ska du välja halvförsäkring. Annars betalar du för något du inte behöver.",
    volviaComercialRecommendationOtherBrand_T1D1: "",
    volviaComercialRecommendationOtherBrand_T1D1V1: "",
    commercialCoverageDescriptionTraficLightTruck: "",
    commercialCoverageDescriptionHalvLightTruck: "",
    commercialCoverageDescriptionHelLightTruck: "",
    commercialRecommendedCoverageDescriptionHelLightTruck: "Key Commercial_Recommended_Coverage_Description_Hel_LightTruck Missing",
    coverageRecommendationDescription_T1:
      "Tänk på att trafikförsäkringen inte täcker skador på din egen bil. Har du en äldre bil med lågt värde kan det vara värt att ta halvförsäkring för att få hjälp med bärgning.\n",
    coverageRecommendationDescription_T1D1:
      "Eftersom bilen har giltig personvagnsgaranti (vagnskadegaranti) rekommenderar vi att du väljer halvförsäkring. Samma skydd som en helförsäkring fast till ett bättre pris. ",
    coverageRecommendationDescription_T1D1V1:
      "Då bilen saknar personvagnsgaranti (vagnskadegaranti) rekommenderar vi helförsäkring. Med en helförsäkring får du ersättning för skador på plåt och lack även om du orsakat skadan själv. ",
  },
  confirmationLinks: {
    checkoutExtraUrl1: {
      urlText: "Link1",
      link: "Link1",
    },
    checkoutExtraUrl2: {
      urlText: "Link2",
      link: "Link2",
    },
  },
};

type TextAction = {
  type: typeof CHANGE_REDIRECT_BUTTON_TEXT;
  newText: { value: string };
};

export const reducer: Reducer<Texts> = (state: Texts = defaults, input: Action): Texts => {
  const action = input as TextAction;

  switch (action?.type) {
    case CHANGE_REDIRECT_BUTTON_TEXT: {
      return { ...state, redirectButtonText: action.newText.value };
    }
    default:
      return state;
  }
};
